import React from 'react';
import shop from 'shopify-buy';
import {encode} from 'shopify-gid';
import cookie from 'js-cookie';

// import algoliasearch from 'algoliasearch';

// const algoliaClient = algoliasearch(
// 	process.env.GATSBY_ALGOLIA_APP_ID,
// 	process.env.GATSBY_ALGOLIA_INDEX_API_KEY,
// );
// const productSearchIndex = algoliaClient.initIndex(
// 	process.env.GATSBY_ALGOLIA_PRODUCT_INDEX,
// );

export const CHECKOUT_KEY = 'pasque_checkout';

const shopify = shop.buildClient({
	domain: process.env.GATSBY_SHOPIFY_DOMAIN,
	storefrontAccessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_API_TOKEN,
});

const ShopContext = React.createContext();
export default ShopContext;

export class ShopContextProvider extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isCartOpen: false,
			isSearchOpen: false,
			products: [],
			shop: {},
			checkout: {lineItems: []},
			error: null,
			successMessage: null,
			successMessageColor: null,
			isHydratingCheckout: false,
			searchResults: [],
		};
	}

	componentDidMount = () => {
		let productsPromise = shopify.product.fetchAll(250);
		let shopPromise = shopify.shop.fetchInfo();

		Promise.all([productsPromise, shopPromise]).then(response => {
			const products = response[0];
			const shop = response[1];

			this.setState({
				shop,
				products,
			});
		});
		this.hydrateCheckout();
	};

	hydrateCheckout = () => {
		const checkoutId = cookie.get(CHECKOUT_KEY);

		this.setState({isHydratingCheckout: true});

		if (checkoutId) {
			shopify.checkout
				.fetch(checkoutId)
				.then(checkout => {
					if (checkout.completedAt) {
						shopify.checkout.create().then(newCheckout => {
							this.setState({
								newCheckout,
							});
						});
					} else {
						this.setState({
							checkout,
						});
					}
				})
				.catch(error => console.warn(error));
		} else {
			shopify.checkout.create().then(checkout => {
				this.setState({
					checkout,
				});
			});
		}
	};

	setCartOpen = boolean => {
		this.setState({
			isCartOpen: boolean,
		});
	};

	setSearchOpen = boolean => {
		this.setState({
			isSearchOpen: boolean,
		});
	};

	addVariantToCart = (variantId, quantity) => {
		const productVariant = encode('ProductVariant', variantId, {
			accessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_API_TOKEN,
		});

		const lineItemsToAdd = [
			{variantId: productVariant, quantity: quantity},
		];
		const checkoutID = this.state.checkout.id;

		shopify.checkout
			.addLineItems(checkoutID, lineItemsToAdd)
			.then(updatedCheckout => {
				cookie.set(CHECKOUT_KEY, this.state.checkout.id, {expires: 25});
				this.setState({
					checkout: updatedCheckout,
					error: null,
					isCartOpen: true,
				});
			})
			.catch(error => {
				this.setState({
					error,
					successMessage: null,
				});
			});
	};

	updateQuantityInCart = (lineItemID, quantity) => {
		const checkoutID = this.state.checkout.id;
		const lineItemsToUpdate = [
			{id: lineItemID, quantity: Number(quantity)},
		];

		shopify.checkout
			.updateLineItems(checkoutID, lineItemsToUpdate)
			.then(updatedCheckout => {
				cookie.set(CHECKOUT_KEY, this.state.checkout.id, {expires: 25});
				this.setState({
					checkout: updatedCheckout,
				});
			});
	};

	removeLineItemInCart = lineItemID => {
		const checkoutID = this.state.checkout.id;

		shopify.checkout
			.removeLineItems(checkoutID, [lineItemID])
			.then(updatedCheckout => {
				this.setState({
					checkout: updatedCheckout,
				});
			});
	};

	clearSuccessMessage = () => {
		this.setState({
			successMessageColor: null,
			successMessage: null,
		});
	};

	fetchProduct = productId => {
		const productVariant = encode('Product', productId, {
			accessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_API_TOKEN,
		});

		return shopify.product
			.fetch(productVariant)
			.then(product => {
				return product;
			})
			.catch(error => {
				console.warn(error);
			});
	};

	searchStore = searchTerm => {
		productSearchIndex
			.search(searchTerm)
			.then(results => {
				this.setState({
					searchResults: results.hits,
				});
			})
			.catch(error => {
				console.log(error);
			});
	};

	render() {
		const value = {
			// values
			products: this.state.products,
			shop: this.state.shop,
			checkout: this.state.checkout,
			isCartOpen: this.state.isCartOpen,
			isSearchOpen: this.state.isSearchOpen,
			successMessage: this.state.successMessage,
			successMessageColor: this.state.successMessageColor,
			searchResults: this.state.searchResults,
			// methods
			hydrateCheckout: this.hydrateCheckout,
			setCartOpen: this.setCartOpen,
			setSearchOpen: this.setSearchOpen,
			addVariantToCart: this.addVariantToCart,
			updateQuantityInCart: this.updateQuantityInCart,
			removeLineItemInCart: this.removeLineItemInCart,
			setSanityProducts: this.setSanityProducts,
			clearSuccessMessage: this.clearSuccessMessage,
			fetchProduct: this.fetchProduct,
			searchStore: this.searchStore,
		};

		return (
			<ShopContext.Provider value={value}>
				{this.props.children}
			</ShopContext.Provider>
		);
	}
}
